import { render, staticRenderFns } from "./StepAcademics.vue?vue&type=template&id=0d8acf3a&scoped=true&"
import script from "./StepAcademics.vue?vue&type=script&lang=js&"
export * from "./StepAcademics.vue?vue&type=script&lang=js&"
import style0 from "./StepAcademics.vue?vue&type=style&index=0&id=0d8acf3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8acf3a",
  null
  
)

export default component.exports